module.exports = __webpack_public_path__ + "static/media/visa_original.39b830d1.svg";